<template>
	<div :class="ClassCustom ? ClassCustom : 'custom-height'">
		<div class="vx-row mb-2">
			<div class="vx-col md:w-full">
				<label class="g-table--title" v-text="$t('Activity.AssignedResources')"></label>
			</div>
		</div>
		<div class="vx-row flex items-center">
			<div class="vx-col md:w-1/5 mt-2">
				<div class="o-span--count bg-primary" v-text="assignedResources.length"></div>
			</div>
			<div class="vx-col md:w-3/5 mt-2">
				<vs-button
					type="border"
					color="#F9841E"
					style="padding: 0.3rem 2.5rem; font-size: 12px; line-height: 15px"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="resourceMounted = true"
					>{{ $t("ButtonAddTypeConfig") }}
				</vs-button>
			</div>
			<div class="vx-col md:w-1/5 flex justify-end mt-2">
				<vx-tooltip
					v-if="assignedResources.length > 1"
					class="cursor-pointer mr-4"
					color="primary"
					position="bottom"
					:title="$t('Crud.Delete')"
					:text="$t('Alarm.DeleteAllResources')"
				>
					<feather-icon
						class="g-label--normal"
						size="small"
						icon="TrashIcon"
						svgClasses="h-5 w-5 text-danger cursor-pointer"
						@click.stop="deleteAll('RESOURCES')"
					/>
				</vx-tooltip>
				<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
					<feather-icon
						id="btn-show-list-resources"
						class="g-label--normal"
						size="small"
						icon="LayoutIcon"
						svgClasses="h-5 w-5 text-dark cursor-pointer"
					/>
					<vs-dropdown-menu style="width: 30%">
						<vx-card no-shadow :title="$t('VisitPointObject.Columns')">
							<p>{{ $t("VisitPointObject.ColumnsText") }}</p>
							<ul class="demo-alignment">
								<li>
									<vs-checkbox class="g-label--normal" v-model="checkBoxID" disabled>ID</vs-checkbox>
								</li>
								<li>
									<vs-checkbox class="g-label--normal" v-model="checkBoxName"
										>{{ $t("Name") }}
									</vs-checkbox>
								</li>
								<li>
									<vs-checkbox class="g-label--normal" v-model="checkBoxLastName"
										>{{ $t("Lastname") }}
									</vs-checkbox>
								</li>
								<li>
									<vs-checkbox class="g-label--normal" v-model="checkBoxIdentification"
										>{{ $t("Identification") }}
									</vs-checkbox>
								</li>
								<li>
									<vs-checkbox class="g-label--normal" v-model="checkBoxEmail"
										>{{ $t("Email") }}
									</vs-checkbox>
								</li>
								<li>
									<vs-checkbox class="g-label--normal" v-model="checkBoxUsername"
										>{{ $t("Username") }}
									</vs-checkbox>
								</li>
							</ul>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<vue-perfect-scrollbar class="scroll-area p-3" :settings="settings">
				<hr style="border: 0.75px solid #a3a3a3" />
				<vs-table
					v-if="assignedResources.length > 0"
					max-items="6"
					:data="assignedResources"
					:search="search"
					:pagination="pagination"
				>
					<template slot="thead">
						<vs-th class="g-table--title"></vs-th>
						<vs-th class="g-table--title">ID</vs-th>
						<vs-th v-show="checkBoxName" class="g-table--title">{{ $t("Name") }}</vs-th>
						<vs-th v-show="checkBoxLastName" class="g-table--title">{{ $t("Lastname") }}</vs-th>
						<vs-th v-show="checkBoxUsername" class="g-table--title">{{ $t("general.User") }}</vs-th>
						<vs-th v-show="checkBoxIdentification" class="g-table--title">{{ $t("Identification") }}</vs-th>
						<vs-th v-show="checkBoxEmail" class="g-table--title">{{ $t("Email") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<vs-td class="g-table--description text-center" :data="data[indextr].id">
								<feather-icon
									class="g-label--normal"
									size="small"
									icon="Trash2Icon"
									svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
									:title="$t('Crud.Delete')"
									@click="removeAssignedResource(data[indextr].id)"
								/>
							</vs-td>
							<vs-td v-show="checkBoxID" class="g-table--description" :data="data[indextr].id">
								{{ data[indextr].id }}
							</vs-td>
							<vs-td v-show="checkBoxName" class="g-table--description" :data="data[indextr].id">
								{{ data[indextr].name.toLowerCase() | capitalize }}
							</vs-td>

							<vs-td v-show="checkBoxLastName" class="g-table--description" :data="data[indextr].id">
								{{ data[indextr].lastname.toLowerCase() | capitalize }}
							</vs-td>

							<vs-td v-show="checkBoxUsername" class="g-table--description" :data="data[indextr].id">
								{{ data[indextr].username }}
							</vs-td>

							<vs-td
								v-show="checkBoxIdentification"
								class="g-table--description"
								:data="data[indextr].id"
							>
								{{ data[indextr].identification }}
							</vs-td>

							<vs-td v-show="checkBoxEmail" class="g-table--description" :data="data[indextr].id">
								{{ data[indextr].email }}
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
				<p v-else class="g-label--normal text-center mt-2" v-text="$t('Resource.NotResources')"></p>
			</vue-perfect-scrollbar>
		</div>
		<!-- VISIT POINT LIST COMPONENT -->
		<popup-customize
			class="vs-popup--content-custom"
			:fullscreen="false"
			:title="null"
			:active="resourceMounted"
			:hidden-boolean="true"
		>
			<resource-list
				v-if="resourceMounted"
				ref="ResourceList"
				:removeColumns="true"
				:customConfig="resourceListConfig"
				@showPopupEmmit="showPopup"
				@closePopup="closePopupEmit"
			>
			</resource-list>
		</popup-customize>
	</div>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import ResourceList from "@/components/resource/user-list/ResourceList.vue";
import moduleResource from "@/store/resource/moduleResource.js";
import PopupCustomize from "../../../core/components/PopupCustomize";

export default {
	props: {
		resource_ids: {
			type: Array,
			default: () => [],
		},
		ClassCustom: {
			type: String,
			default: "",
		},
		search: {
			type: Boolean,
			default: false,
		},
		pagination: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		PopupCustomize,
		vSelect,
		VuePerfectScrollbar,
		VisitPointList,
		ResourceList,
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			resourceMounted: false,
			activeItem: 0,
			resourceListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: ["id", "name", "lastname", "username", "email", "identification", "alias", "status"],
				actionDropdown: false,
				btnAssigResources: true,
				popupMode: true,
				activeHeaderCheckboxSelection: true,
			},
			searchQuery: "",
			visit_point_nav: 0,
			visit_point_selected: [],
			searchField: {value: "Name", label: this.$t("Name")},
			checkBoxName: true,
			checkBoxLastName: false,
			checkBoxIdentification: false,
			checkBoxEmail: false,
			checkBoxUsername: false,
			checkBoxID: true,
		};
	},
	computed: {
		// Integrations groups
		assignedResources() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
			];
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getAssignedResources() {
			this.openLoading();
			const data = {
				ids: this.resource_ids,
				fields: ["id", "name", "lastname", "username", "identification", "email"],
			};
			this.$store
				.dispatch("moduleResource/getResourcesByFilter", data, {
					component: "activitycreate",
				})
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
					this.$vs.notify({
						color: "danger",
						title: this.$t("Alarm.ErrorGetResourceFilter.Title"),
						text: this.$t("Alarm.ErrorGetResourceFilter.Text"),
					});
				});
		},
		showPopup() {
			this.resourceMounted = false;
			this.searchQuery = "";
		},
		removeAssignedResource(id) {
			// Delete item form store
			this.$store.dispatch("moduleResource/removeResourceActivity", id);
		},
		scrollHandle(evt) {},
		searchResource() {
			this.$refs.VisitPointList.searchResource2(this.searchField.value, this.searchQuery);
		},
		refres() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = "";
		},
		deleteAll(value) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${value}"`,
				accept: value === "RESOURCES" ? this.deleteAllResources : this.deleteAllEmails,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAllResources() {
			this.$store.dispatch("moduleResource/cleanResourceActivity");
		},
		closePopupEmit(val) {
			this.resourceMounted = val;
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (this.resource_ids.length > 0) {
			this.getAssignedResources();
		}
	},
	mounted() {
		this.searchQuery = "";
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}

.custom-height-report {
	height: 63vh;
}
</style>
